import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
      name: "dashboard",
      meta: {main_page: true},
      component: () => import("@/core/plugins/TitleRibbon/index"),
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          meta: {main_page: true},
          component: () => import("@/core/plugins/TitleRibbon/Dashboard")
        },
        {
          path: '/person/info',
          name: 'personInfo',
          meta: {has_ribbon: true, title: 'اطلاعات کاربر با کدملی', permission: 'admin_access'},
          component: () => import('@/view/pages/person/info.vue'),
        },
        {
          path: "/sendAds",
          name: "sendADS",
          component: () =>
              import("@/view/pages/vue-bootstrap/VueBootstrap.vue"),
          children: [
            {
              path: "taki",
              name: "singleAds",
              meta: {has_ribbon: true, title: 'ارسال آگهی شخصی', permission: 'divar_send'},
              component: () => import("@/view/pages/ads/singleAds/taki")
            },
            {
              path: "info",
              name: "singleAds",
              meta: {has_ribbon: true, title: 'ارسال آگهی شخصی', permission: 'divar_send'},
              component: () => import("@/view/pages/etelaat")
            },
            {
              path: "real/estate",
              name: "agency",
              meta: {has_ribbon: true, title: 'ارسال آگهی املاک', permission: "all"},
              component: () => import("@/view/pages/ads/singleAds/agency/simpleAds")
            },
            {
              path: "multi",
              name: "multiAds",
              meta: {has_ribbon: true, title: 'ارسال آگهی گروهی', permission: 'divar_send'},
              component: () => import("@/view/pages/ads/mutliAds/divarMulti")
            },
            {
              path: "gradual",
              name: "gradual",
              meta: {has_ribbon: true, title: 'ارسال آگهی تدریجی', permission: 'divar_send'},
              component: () => import("@/view/pages/ads/sendAds/Gradual")
            },
            {
              path: "smart",
              name: "smart",
              meta: {has_ribbon: true, title: 'ارسال آگهی هوشمند', permission: 'divar_send'},
              component: () => import("@/view/pages/ads/sendAds/Smart")
            },
            {
              path: "default",
              name: "default",
              meta: {has_ribbon: true, title: 'ثبت آگهی پیشفرض', permission: 'default_store'},
              component: () => import("@/view/pages/ads/default/createDefault")
            },
            {
              path: "divarNews/list",
              name: "divarNews/list",
              meta: {has_ribbon: true, title: 'لیست تازه های دیوار', permission: 'advertiseFuture_list'},
              component: () => import("@/view/pages/ads/divar/newsList")
            },
            {
              path: "sendToFuture",
              name: "sendToFuture",
              meta: {
                has_ribbon: true,
                title: 'مانیتورینگ ارسال به آینده',
                permission: 'advertiseFuture_list'
              },
              component: () =>
                  import("@/view/pages/monitoring/sendToFuture")
            },
            {
              path: "myAdsList",
              name: "myAdsList",
              meta: {has_ribbon: true, title: 'لیست آگهی های من', permission: 'advertiseNormal_list'},
              component: () => import("@/view/pages/ads/adsList/myAds")
            },
            {
              path: "smartsList",
              name: "smartsList",
              meta: {has_ribbon: true, title: 'لیست آگهی های هوشمند/تدریجی', permission: 'smarts_list'},
              component: () => import("@/view/pages/ladder/ladderList")
            },
            {
              path: "futureList",
              name: "futureList",
              meta: {
                has_ribbon: true,
                title: 'لیست آگهی های زماندار',
                permission: 'advertiseFuture_list'
              },
              component: () =>
                  import("@/view/pages/ads/adsList/futureList")
            },
            {
              path: "defaultList",
              name: "defaultList",
              meta: {
                has_ribbon: true,
                title: 'لیست آگهی های پیشفرض',
                permission: 'defaultAdvertise_list'
              },
              component: () => import("@/view/pages/ads/default/deafultAdsList")
            },
            {
              path: "defTextList",
              name: "defTextList",
              meta: {has_ribbon: true, title: 'لیست متن پیشفرض', permission: 'defaultText_list'},
              component: () => import("@/view/pages/ads/default/defaultTextList")
            },
            {
              path: "edit",
              name: "edit",
              meta: {has_ribbon: false, title: '', permission: 'divar_update'},
              component: () => import("@/view/pages/ads/singleAds/editSimple")
            },
          ]
        },
        {
          path: "/adsList",
          name: "AdsLists",
          component: () => import("@/view/pages/vue-bootstrap/VueBootstrap.vue"),
          children: [
            {
              path: "divarNews/list",
              name: "divarNews/list",
              meta: {has_ribbon: true, title: 'لیست تازه های دیوار', permission: 'advertiseFuture_list'},
              component: () => import("@/view/pages/ads/divar/newsList")
            },
            {
              path: "renewAds",
              name: "renewAds",
              meta: {has_ribbon: true, title: 'تمدید اتوماتیک', permission: 'advertiseFuture_list'},
              component: () => import("@/view/pages/ads/adsList/reNewsAdsList")
            },
            {
              path: "autoPayAds",
              name: "autoPayAds",
              meta: {has_ribbon: true, title: 'پرداخت اتوماتیک', permission: 'advertiseFuture_list'},
              component: () => import("@/view/pages/ads/adsList/autoPayAds.vue")
            },
            {
              path: "adAnalyzer",
              name: "autoPayAds",
              meta: {has_ribbon: true, title: 'آنالیزور آگهی', permission: 'advertiseFuture_list'},
              component: () => import("@/view/pages/ads/adsList/adAnalyzer.vue")
            },
            {
              path: "adAnalyzer/:id",
              name: "autoPayAds",
              meta: {has_ribbon: true, title: 'آمار بازدید', permission: 'advertiseFuture_list'},
              component: () => import("@/view/pages/ads/adsList/adAnalyzerId.vue")
            },
            {
              path: "sendToFuture",
              name: "sendToFuture",
              meta: {has_ribbon: false, title: '', permission: 'advertiseFuture_list'},
              component: () => import("@/view/pages/monitoring/sendToFuture")
            },
            {
              path: "myAdsList",
              name: "myAdsList",
              meta: {has_ribbon: true, title: 'لیست آگهی های من', permission: 'advertiseNormal_list'},
              component: () => import("@/view/pages/ads/adsList/myAds")
            },
            {
              path: "smartsList",
              name: "smartsList",
              meta: {has_ribbon: true, title: 'لیست آگهی های هوشمند/تدریجی', permission: 'smarts_list'},
              component: () => import("@/view/pages/ladder/ladderList")
            },
            {
              path: "futureList",
              name: "futureList",
              meta: {
                has_ribbon: true,
                title: 'لیست آگهی های زماندار',
                permission: 'advertiseFuture_list'
              },
              component: () => import("@/view/pages/ads/adsList/futureList")
            },
            {
              path: "defaultList",
              name: "defaultList",
              meta: {
                has_ribbon: true,
                title: 'لیست آگهی های پیشفرض',
                permission: 'defaultAdvertise_list'
              },
              component: () => import("@/view/pages/ads/default/deafultAdsList")
            },
            {
              path: "defTextList",
              name: "defTextList",
              meta: {has_ribbon: true, title: 'لیست متن پیشفرض', permission: 'defaultText_list'},
              component: () => import("@/view/pages/ads/default/defaultTextList")
            },
            {
              path: "payments",
              name: "payments",
              meta: {has_ribbon: true, title: 'پرداختی‌های دیوار', permission: 'defaultText_list'},
              component: () => import("@/view/pages/ads/divar/payList.vue")
            },
          ]
        },
        {
          path: "/numbers",
          name: "Numbers",
          component: () =>
              import("@/view/pages/vue-bootstrap/VueBootstrap.vue"),
          children: [
            // {
            //     path: "rentNumber",
            //     name: "rentNumbers",
            //     meta: {has_ribbon: true, title: 'اجاره شماره', permission: 'divar_phone'},
            //     component: () => import("@/view/pages/numbers/rentNumber")
            // },
            {
              path: "addNewNumber/add",
              name: "addNewNumber",
              meta: {has_ribbon: true, title: 'افزودن شماره خود', permission: 'divar_phone'},
              component: () => import("@/view/pages/numbers/addNewNumbers")
            },
            {
              path: "numberList",
              name: "numberList",
              meta: {has_ribbon: true, title: 'لیست شماره های من', permission: 'number_list'},
              component: () => import("@/view/pages/numbers/numbersList")
            },
          ]
        },
        {
          path: "/Tools",
          name: "Tools",
          component: () =>
              import("@/view/pages/vue-bootstrap/VueBootstrap.vue"),
          children: [
            {
              path: "gradualLadder",
              name: "gradualLadder",
              meta: {has_ribbon: true, title: 'ارتقا تدریجی آگهی', permission: "file_list"},
              component: () => import("../src/view/pages/graduals/gradualComponents")
            },
            {
              path: "SmartLadder",
              name: "SmartLadder",
              meta: {has_ribbon: true, title: 'ارتقا هوشمند آگهی', permission: "file_list"},
              component: () => import("../src/view/pages/smarts/smartComponents")
            },
            {
              path: "divarNews",
              name: "divarNews",
              meta: {
                has_ribbon: true,
                title: 'مانیتورینگ تازه های دیوار',
                permission: 'advertiseFuture_list'
              },
              component: () => import("@/view/pages/monitoring/divarNews")
            },
            {
              path: "uploader",
              name: "uploadCenter",
              meta: {has_ribbon: true, title: 'آپلود سنتر', permission: "file_list"},
              component: () =>
                  import("@/view/pages/uploadCenter/uploader")
            },
            {
              path: "attack",
              name: "Tools/attack",
              meta: {has_ribbon: true, title: 'حمله', permission: "file_list"},
              component: () =>
                  import("@/view/pages/ads/divar/attack")
            },
            {
              path: "autoChats",
              name: "autoChats",
              meta: {has_ribbon: true, title: 'لیست چت ها', permission: 'chat_list'},
              component: () => import("@/view/pages/chats/autoChats")
            },

            {
              path: "unrepeatAbleText",
              name: "unrepeatAbleText",
              meta: {has_ribbon: true, title: 'خرید متن غیرتکراری', permission: 'defaultText_list'},
              component: () => import("@/view/pages/unrepeatAbleText/unrepeatAbleText")
            },
            {
              path: "defaultText",
              name: "defaultText",
              meta: {has_ribbon: true, title: 'ایجاد متن پیشفرض', permission: 'defaultText_list'},
              component: () => import("@/view/pages/ads/default/createDefaultText")
            },
            {
              path: "excelList",
              name: "excelList",
              meta: {has_ribbon: true, title: 'فایل های اکسل', permission: 'excel_index'},
              component: () => import("@/view/pages/ads/excel/files")
            },
            {
              path: "gradualShop",
              name: "gradualShop",
              meta: {
                has_ribbon: true,
                title: 'نردبان تدریجی فروشگاهی',
                permission: 'advertiseNumber_list'
              },
              component: () => import("@/view/pages/ladderShop/GraduaShop")
            },
            {
              path: "smartShop",
              name: "smartShop",
              meta: {
                has_ribbon: true,
                title: 'نردبان هوشمند فروشگاهی',
                permission: 'advertiseNumber_list'
              },
              component: () => import("@/view/pages/ladderShop/SmartShop")
            },
          ]
        },
        {
          path: "/Monitoring",
          name: "Monitoring",
          component: () => import("@/view/pages/vue-bootstrap/VueBootstrap.vue"),
          children: [
            {
              path: "similarAds",
              name: "vue-bootstrap-layout-grid-system",
              meta: {has_ribbon: true, title: 'آگهی های مشابه', permission: 'divar_search'},
              component: () =>
                  import("@/view/pages/ads/similarAds/mainSimilar")
            },
            {
              path: "NewestInDivar",
              name: "divarNewList",
              meta: {
                has_ribbon: true,
                title: 'مونیتورینگ تازه های دیوار',
                permission: 'defaultText_list'
              },
              component: () => import("@/view/pages/ads/divar/NewestDivar")
            },
            {
              path: "NewestInDivar/add",
              name: "divarNew",
              meta: {has_ribbon: false, title: '', permission: 'admin_monitor_smart_news_index'},
              component: () => import("@/view/pages/ads/divar/AddNews")
            },
            {
              path: "smartMonitoring",
              name: "smartMonitoring",
              meta: {
                has_ribbon: true,
                title: 'لیست آگهی های هوشمند/تدریجی',
                permission: 'admin_monitor_smart_index'
              },
              component: () => import("@/view/pages/monitoring/smartMonitoring")
            },
            {
              path: "numberMonitoring",
              name: "vue-bootstrap-input-group",
              meta: {has_ribbon: true, title: 'مانیتورینگ بسته ها', permission: 'file_list'},
              component: () =>
                  import("@/view/pages/monitoring/numberMonitoring")
            },
            {
              path: "chargeMonitoring",
              name: "chargeMonitoring",
              meta: {
                has_ribbon: true,
                title: 'مانیتورینگ شارژ',
                permission: "admin_monitor_charge_index"
              },
              component: () =>
                  import("@/view/pages/monitoring/chargeMonitoring")
            },
            {
              path: "numberMonitoring",
              name: "numberMonitoring",
              meta: {has_ribbon: true, title: '', permission: 'file_list'},
              // todo check permissons
              component: () =>
                  import("@/view/pages/monitoring/numberMonitoring")
            },
            {
              path: "defaultAdsMonitor",
              name: "defaultAdsMonitor",
              meta: {has_ribbon: true, title: 'مانیتورینگ متن غیرتکراری', permission: 'divar_send'},
              component: () =>
                  import("@/view/pages/monitoring/defAdsMonitoring")
            },
            {
              path: "payMonitoring",
              name: "payMonitoring",
              meta: {
                has_ribbon: true,
                title: 'مانیتورینگ پرداخت ها',
                permission: 'admin_monitor_payment_index'
              },
              component: () =>
                  import("@/view/pages/monitoring/payMonitoring")
            },
            {
              path: "adsMonitoring",
              name: "adsMonitoring",
              meta: {has_ribbon: true, title: 'مانیتورینگ آگهی ها', permission: 'divar_send'},
              component: () =>
                  import("@/view/pages/monitoring/AdsMonitoring")
            },
            {
              path: "sendToFuture",
              name: "sendToFuture",
              meta: {
                has_ribbon: true,
                title: 'لیست ارسال به آینده',
                permission: 'admin_monitor_futureAdvertise_index'
              },
              component: () =>
                  import("@/view/pages/monitoring/sendToFuture")
            },
            {
              path: "DivarNews",
              name: "DivarNews",
              meta: {has_ribbon: false, title: '', permission: 'admin_monitor_smart_news_index'},
              component: () =>
                  import("@/view/pages/monitoring/divarNews")
            },
            {
              path: "inAction",
              name: "inAction",
              meta: {has_ribbon: true, title: 'در دست اقدام', permission: 'divar_send'},
              component: () =>
                  import("@/view/pages/jobs/jobsList")
            },
            {
              path: "chatMonitor",
              name: "chatMonitor",
              meta: {has_ribbon: true, title: 'مانیتورینگ چت', permission: 'admin_monitor_chat_index'},
              component: () =>
                  import("@/view/pages/monitoring/chatMonitoring")
            },
            {
              path: "estates",
              name: "estates",
              meta: {has_ribbon: true, title: 'ارسال آگهی پنل املاک', permission: 'divar_send_agency'},
              component: () =>
                  import("@/view/pages/ads/panels/estates")
            },
            {
              path: "market",
              name: "market",
              meta: {has_ribbon: true, title: 'ارسال آگهی پنل فروشگاهی', permission: 'divar_send_shop'},
              component: () =>
                  import("@/view/pages/ads/panels/marketPlace")
            },
            {
              path: "estatesLadder",
              name: "estatesLadder",
              meta: {
                has_ribbon: true,
                title: 'نردبان هوشمند املاک',
                permission: 'divar_real_estate_remaining'
              },
              component: () =>
                  import("@/view/pages/ads/panels/ladder/smartLadder")
            },
            {
              path: "estateGradual",
              name: "estateGradual",
              meta: {
                has_ribbon: true,
                title: 'نردبان تدریجی املاک',
                permission: 'divar_real_estate_remaining'
              },
              component: () => import("@/view/pages/ads/panels/ladder/gradualLadder")
            },
          ]
        },
        {
          path: "/admin/user",
          name: "AdminUSer",
          component: () => import("@/view/pages/vue-bootstrap/VueBootstrap.vue"),
          children: [
            {
              path: "phones",
              name: "phones",
              meta: {has_ribbon: true, title: 'لیست شماره ها', permission: 'admin_number_list'},
              component: () =>
                  import("@/view/pages/monitoring/userNumMonitor")
            },
          ]
        },
        {
          path: "/admin/tarefe",
          name: "AdminTarefe",
          component: () => import("@/view/pages/vue-bootstrap/VueBootstrap.vue"),
          children: [
            {
              path: "createTarefeList",
              name: "createTarefeList",
              meta: {has_ribbon: true, title: 'ایجاد بسته شماره', permission: 'admin_number_pack_list'},
              component: () =>
                  import("@/view/pages/tarefe/createTarefe")
            },
            {
              path: "showTarefe",
              name: "showTarefe",
              meta: {
                has_ribbon: true,
                title: 'لیست بسته شماره ها',
                permission: 'admin_monitor_pack_index'
              },
              component: () =>
                  import("@/view/pages/tarefe/showTarefeList")
            },
            {
              path: "otherTarefe",
              name: "otherTarefe",
              meta: {has_ribbon: true, title: 'لیست تعرفه ها', permission: 'admin_monitor_pack_index'},
              component: () => import("@/view/pages/tarefe/allTarefeList")
            },
            {
              path: "otherTarefe/add",
              name: "otherTarefe",
              meta: {has_ribbon: true, title: 'ایجاد تعرفه', permission: 'admin_other_pack_list'},
              component: () => import("@/view/pages/tarefe/createAlltarefe")
            },
          ]
        },
        {
          path: "/admin/setting",
          name: "Setting",
          component: () => import("@/view/pages/vue-bootstrap/VueBootstrap.vue"),
          children: [
            {
              path: "adminSetting",
              name: "adminSetting",
              meta: {has_ribbon: true, title: 'تنظیمات سایت', permission: 'bazaar_setting'},
              component: () =>
                  import("@/view/pages/ads/systemSetting")
            },
          ]
        },
        {
          path: "/admin/user/number/pack",
          name: "userNumberPack",
          component: () => import("@/view/pages/vue-bootstrap/VueBootstrap.vue"),
          children: [
            {
              path: "new",
              name: "newUserNumberPack",
              meta: {has_ribbon: true, title: 'ثبت شماره برای کاربر', permission: 'create_new_pack'},
              component: () =>
                  import("@/view/pages/numbers/UserNumberPack.vue")
            },
          ]
        }
      ]
    },
  ]
});
